export default __webpack_public_path__ + "static/media/insights-splash-desktop.9a499387.png";